export default __webpack_public_path__ + "static/media/CapitaSprintShowcase.jpg?.014a04f5";